import React from "react";
import { Button } from "@cdk-uip/react-button";

/**
 * @typedef {{ text: string; goTo: string; }} RoutingNavOption
 * @typedef {{ text: string; onNavigate: (props: P) => void; }} FunctionNavOption
 * @typedef {RoutingNavOption | FunctionNavOption<P>} NavOption
 * @template {any} P
 */

/**
 * Wrap a component to add a button to perform a navigation above it.
 *
 * Navigation options contain `text` to display on the button, and either:
 * - `goTo`: a path to navigate to by pushing to React Router's history, or
 * - `onNavigate`: a function to invoke when the button is clicked. This function
 *   receives the wrapper's props as its sole argument, and its return value is ignored.
 *
 * If using `goTo`, you must wrap the resulting component with a React Router
 * consumer, or somehow supply a `history` prop for the active router to the
 * resulting component.
 *
 * @template {any} P
 * @param navOptions {NavOption<P>[]}
 * @returns {(Component: React.ComponentType<P>) => React.FC<P>}
 * A component wrapper. Invoke with one argument, the component to be wrapped.
 */
export default function withNavigation(navOptions = []) {
  return (Component) => (props) =>
    (
      <>
        <br />
        {navOptions.map(({ text, goTo, onNavigate }) => (
          <Button
            key={goTo || text}
            raised
            onClick={() =>
              onNavigate ? onNavigate(props) : props.history.push(goTo)
            }
            className="cdk-navigation-button"
          >
            {text}
          </Button>
        ))}
        <br />
        <br />
        <Component {...props} />
      </>
    );
}
